<template>
  <n-modal v-bind="$props">
    <!-- prettier-ignore -->
    <Form ref="modalForm" class="n-modal-container" :label-width="labelWidth" :model="model" @submit.native.prevent>
      <n-row-col2>
        <n-field-id v-model="model.id" label="id" disabled />
        <ns-company v-model="model.companyId" :error="error.companyId" :disabled="!isCreate || disabled" />
      </n-row-col2>
      <n-row-col2>
        <n-field-id v-model="model.customerId" field-name="customerId" label="customerId" :error="error.customerId" :disabled="isEdit || disabled" />
        <n-field-selection v-model="model.campaignId" field-name="campaignId" selection-name="company.campaign" label="campaign" :error="error.campaignId" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <n-field-boolean v-model="model.cohortIn" label="cohortIn" :error="error.cohortIn" :disabled="disabled" />
        <n-field-enum v-model="model.status" :error="error.status" enum-name="CustomerSegmentStatus" label="status" :disabled="disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- cohortId -->
        <n-field-text v-model="model.cohortId" field-name="cohortId" label="cohortId" :error="error.cohortId" :disabled="isEdit || disabled" />
        <!-- cohortName -->
        <n-field-text v-model="model.cohortName" field-name="cohortName" label="cohortName" :error="error.cohortName" :disabled="isEdit || disabled" />
      </n-row-col2>
      <n-row-col2>
        <!-- segmentDate -->
        <n-field-date v-model="model.segmentDate" label="segmentDate" disabled />
        <!-- segmentTime -->
        <n-field-datetime v-model="model.segmentTime" label="segmentTime" disabled />
      </n-row-col2>
      <n-row-col2>
        <!-- offerId -->
        <n-field-id v-model="model.offerId" label="offerId" disabled />
        <!-- computedTime -->
        <n-field-text v-model="model.computedTime" field-name="computedTime" label="computedTime" :error="error.computedTime" :disabled="isEdit || disabled" />
      </n-row-col2>
      <n-row-col1>
        <!-- messageId -->
        <n-field-text v-model="model.messageId" field-name="messageId" label="messageId" :error="error.messageId" :disabled="isEdit || disabled" />
      </n-row-col1>
    </Form>
  </n-modal>
</template>

<script>
import NModal from '@/components/common/NModal';
import { validate, update, add } from '@/api/customer/customer-customer-segment';

export default NModal.extend({
  name: 'ModalCustomerSegment',
  components: { NModal },

  methods: {
    doValidate() {
      return validate(this.model);
    },

    doSubmit() {
      return this.isCreate ? add(this.model) : update(this.model);
    },
  },
});
</script>
